<div *ngIf="sponsorLogos && sponsorLogos.length" class="cart-sponsor-banner">
  <img
    *ngFor="let sponsor of sponsorLogos; trackBy: trackBySponsorKey"
    class="cart-sponsor-banner-img"
    [src]="sponsor.url"
    alt=""
    (error)="onImageError(sponsor.key)"
  />
</div>
